import loadable from 'helper/loadable'

const Login = loadable(() => import('js/view/page/login'))
const Home = loadable(() => import('js/view/page/home'))

export {
  Login,
  Home
}
